module.exports = __webpack_public_path__ + "static/media/Somaiya-Trust-Logo-01.d94e0632.svg";